export const BrandsSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.72848 16.1369C3.18295 14.5914 2.41018 13.8186 2.12264 12.816C1.83509 11.8134 2.08083 10.7485 2.57231 8.61875L2.85574 7.39057C3.26922 5.59881 3.47597 4.70292 4.08944 4.08944C4.70292 3.47597 5.59881 3.26922 7.39057 2.85574L8.61875 2.57231C10.7485 2.08083 11.8134 1.83509 12.816 2.12264C13.8186 2.41018 14.5914 3.18295 16.1369 4.72848L17.9665 6.55812C20.6555 9.24711 22 10.5916 22 12.2623C22 13.933 20.6555 15.2775 17.9665 17.9665C15.2775 20.6555 13.933 22 12.2623 22C10.5916 22 9.24711 20.6555 6.55812 17.9665L4.72848 16.1369Z"
        stroke="#667085"
      />
      <path
        d="M10.0212 10.2931C10.8023 9.51207 10.8023 8.24574 10.0212 7.46469C9.24016 6.68364 7.97383 6.68364 7.19278 7.46469C6.41173 8.24574 6.41173 9.51207 7.19278 10.2931C7.97383 11.0742 9.24016 11.0742 10.0212 10.2931Z"
        stroke="#667085"
      />
      <path
        d="M11.5417 18.5L18.5208 11.5208"
        stroke="#667085"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const MenSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2645_11467)">
        <path
          d="M20.6655 18.7219C20.1382 17.8222 19.3224 17.2811 18.5374 16.92C17.7519 16.5593 16.9748 16.3645 16.5073 16.1879C16.1375 16.0503 15.7333 15.8353 15.4454 15.6033C15.3014 15.488 15.1875 15.3687 15.1184 15.2648C15.0479 15.1597 15.026 15.0791 15.0264 15.0248C15.0264 14.6527 15.0264 14.4848 15.0264 13.9192C15.5219 13.3676 16.2339 12.5131 16.5265 11.1582C16.6287 11.112 16.7298 11.0601 16.8272 10.9924C17.0696 10.8252 17.2752 10.5817 17.4495 10.2517C17.6252 9.92002 17.7802 9.49561 17.9461 8.91577C18.03 8.62116 18.0687 8.36564 18.0687 8.13844C18.0694 7.87612 18.0152 7.64831 17.9161 7.46353C17.7957 7.23703 17.6154 7.09472 17.4472 7.00978C17.4539 6.99497 17.46 6.98316 17.4667 6.96731C17.5924 6.66628 17.7215 6.24961 17.7222 5.77092C17.7202 5.02823 17.5692 3.62353 16.7705 2.35369C16.3711 1.72092 15.8034 1.12594 15.0183 0.69511C14.2339 0.263625 13.2386 -0.000327819 12.0002 3.05567e-07C10.7616 -0.000327819 9.76648 0.263625 8.98203 0.69511C7.80246 1.34236 7.12085 2.35434 6.74431 3.31884C6.36607 4.28634 6.27874 5.21269 6.27809 5.77097C6.27874 6.24966 6.40788 6.66628 6.5336 6.96736C6.54068 6.98423 6.54743 6.99703 6.55451 7.01288C6.52385 7.02806 6.49484 7.03819 6.46348 7.05736C6.32388 7.14398 6.18265 7.27884 6.08426 7.46358C5.98517 7.64836 5.93084 7.87617 5.93121 8.13848C5.93154 8.36634 5.97031 8.62191 6.05421 8.91581C6.27602 9.6885 6.47627 10.1874 6.73554 10.5535C6.86534 10.7352 7.01262 10.8812 7.17312 10.9925C7.27052 11.0602 7.37168 11.1121 7.47382 11.1583C7.76642 12.5131 8.47835 13.3677 8.97392 13.9193C8.97392 14.4842 8.97392 14.6528 8.97392 15.0249C8.97495 15.0712 8.95165 15.1564 8.87477 15.266C8.76284 15.4301 8.54271 15.6263 8.28757 15.7922C8.03304 15.9591 7.74312 16.1003 7.50007 16.186C7.18423 16.2972 6.72945 16.422 6.23154 16.5976C5.48482 16.8622 4.6286 17.2435 3.94292 17.9278C3.25554 18.6098 2.76748 19.6096 2.77151 20.981C2.77151 21.1556 2.77924 21.3363 2.79509 21.5237C2.80521 21.6404 2.84637 21.7371 2.89587 21.8197C2.9906 21.9734 3.11904 22.0924 3.28015 22.2138C3.56196 22.4231 3.9537 22.6284 4.46238 22.8317C5.98442 23.4365 8.55888 23.9991 12.0001 24.0001C14.7961 24.0001 17.022 23.6266 18.573 23.1637C19.349 22.9315 19.9555 22.6786 20.391 22.4278C20.6095 22.3011 20.7851 22.1767 20.924 22.0415C20.9935 21.9734 21.0541 21.9019 21.1044 21.8197C21.1539 21.7371 21.195 21.6403 21.2052 21.5237C21.2207 21.3362 21.2284 21.1562 21.2284 20.9823C21.2295 20.0683 21.0168 19.32 20.6655 18.7219ZM15.2647 16.4084C15.2819 16.4198 15.3011 16.428 15.3186 16.4394L13.9934 19.6776L12.3956 17.6799L14.7236 15.9691C14.8827 16.1316 15.0658 16.2775 15.2647 16.4084ZM8.17367 10.8168L8.13523 10.5994L7.92757 10.5252C7.79543 10.478 7.69465 10.4298 7.60667 10.3687C7.47687 10.2771 7.35921 10.152 7.22173 9.89545C7.08584 9.64059 6.94188 9.26002 6.78448 8.7075C6.71538 8.46581 6.69073 8.27803 6.69073 8.13848C6.6911 7.97667 6.72209 7.88161 6.75377 7.82194C6.80168 7.73494 6.86032 7.69786 6.93513 7.66791C6.98637 7.64836 7.04065 7.64095 7.07131 7.63823L7.58201 7.74713L8.19556 8.47495L8.52321 8.39874C8.52321 8.39874 8.63243 6.35048 8.63243 5.78077C8.63243 5.21142 9.72467 4.89548 11.9998 4.89548C14.2752 4.89548 15.3675 5.21138 15.3675 5.78077C15.3675 6.35048 15.4767 8.39874 15.4767 8.39874L15.8044 8.47495L16.4702 7.68544L16.9101 7.63791C16.9344 7.6372 17.0551 7.64902 17.135 7.70227C17.1784 7.72992 17.2139 7.76227 17.2462 7.82194C17.2779 7.88161 17.3089 7.97634 17.3096 8.13848C17.3096 8.27803 17.2847 8.46544 17.2159 8.7075C17.0066 9.44508 16.8188 9.87389 16.6465 10.1119C16.5602 10.2319 16.4813 10.3074 16.3937 10.3687C16.3057 10.4298 16.2049 10.478 16.0728 10.5252L15.8651 10.5994L15.8267 10.8168C15.5836 12.1777 14.8825 12.9429 14.3646 13.5197L14.2672 13.6279V13.7739C14.2672 14.4639 14.2672 14.6217 14.2672 15.0249C14.2675 15.2069 14.3178 15.3748 14.3936 15.5258L12.0002 17.2849L9.60298 15.5232C9.67985 15.3735 9.73245 15.2083 9.7331 15.0249C9.7331 14.6217 9.7331 14.4643 9.7331 13.7739V13.6279L9.63565 13.5197C9.11787 12.9429 8.41671 12.1777 8.17367 10.8168ZM9.00227 16.2122C9.0987 16.1353 9.19006 16.0537 9.27434 15.9675L11.6047 17.6799L10.0069 19.6777L8.68207 16.4401C8.7926 16.3686 8.90013 16.293 9.00227 16.2122ZM20.4494 21.4333C20.4332 21.4589 20.3735 21.526 20.2691 21.6025C20.0712 21.7515 19.7273 21.939 19.2614 22.1244C17.8601 22.684 15.3587 23.2416 12.0002 23.2409C9.27298 23.2409 7.11279 22.8748 5.64467 22.4359C4.91145 22.2174 4.35017 21.9788 3.98876 21.7698C3.8081 21.666 3.67831 21.5688 3.60752 21.4988C3.57584 21.4684 3.55831 21.4455 3.5502 21.4327C3.5381 21.2762 3.53098 21.1245 3.53098 20.9809C3.53201 20.1813 3.71065 19.5789 3.98909 19.0999C4.40576 18.3832 5.06815 17.9244 5.77643 17.5977C6.48467 17.2707 7.21685 17.0894 7.75221 16.9019C7.89617 16.8507 8.04616 16.7843 8.19649 16.7111L9.85099 20.7564L12.0001 18.0697L14.1491 20.7564L15.8046 16.7091C15.9499 16.7795 16.0966 16.8452 16.2409 16.8992C16.6002 17.0333 17.0422 17.1574 17.5107 17.3246C18.2129 17.5741 18.9616 17.9186 19.5183 18.4735C20.0728 19.0311 20.4645 19.7842 20.4689 20.9822C20.469 21.1258 20.4622 21.2765 20.4494 21.4333Z"
          fill="#667085"
        />
        <path
          d="M11.9894 22.4607C12.1681 22.4607 12.313 22.3158 12.313 22.1371C12.313 21.9584 12.1681 21.8135 11.9894 21.8135C11.8107 21.8135 11.6658 21.9584 11.6658 22.1371C11.6658 22.3158 11.8107 22.4607 11.9894 22.4607Z"
          fill="#667085"
        />
        <path
          d="M12.0109 20.4544C12.1896 20.4544 12.3345 20.3095 12.3345 20.1308C12.3345 19.952 12.1896 19.8071 12.0109 19.8071C11.8321 19.8071 11.6873 19.952 11.6873 20.1308C11.6873 20.3095 11.8321 20.4544 12.0109 20.4544Z"
          fill="#667085"
        />
      </g>
      <defs>
        <clipPath id="clip0_2645_11467">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WomenSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.72448 12.3408C6.17055 12.4079 5.96973 12.7302 5.96973 13.2415C5.96973 13.5824 6.33566 13.8641 7.06739 14.0865C7.89371 19.412 16.4434 19.412 16.9576 13.6575C17.6323 13.2563 17.9697 12.9664 17.9697 12.788C17.9697 12.46 17.8469 12.2288 17.2111 12.0286"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.96973 10.0286C8.72163 8.52852 8.99812 7.02856 8.99812 7.02856C8.99812 7.02856 10.8368 9.23268 15.9697 10.0286"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8896 3.71313C8.68475 3.89499 6.96111 5.2616 5.88477 6.84595C5.30705 7.69648 4.91892 8.60666 4.74414 9.42114H4.74316C4.62041 9.99352 4.60686 10.5118 4.69922 10.929L4.54688 11.0168C4.43344 10.5577 4.44909 9.99296 4.5791 9.38696C4.75865 8.55049 5.15593 7.6221 5.74414 6.7561C6.84134 5.141 8.61166 3.73138 10.8896 3.54907V3.71313ZM11.8896 3.54028C14.1231 3.6462 15.6694 4.46419 16.7031 5.60181C17.6838 6.68131 18.1967 8.04289 18.4033 9.34204L18.2363 9.35864C18.0324 8.0844 17.5292 6.7581 16.5771 5.71021C15.5774 4.60978 14.0771 3.80986 11.8896 3.70435V3.54028Z"
        fill="#667085"
        fill-opacity="0.9"
        stroke="#667085"
      />
      <path
        d="M11.6514 1.63013C11.8366 1.69627 12.0055 1.79072 12.1562 1.89771C12.4319 2.09333 12.6696 2.3456 12.8633 2.59106C12.9921 2.75432 13.1008 2.91789 13.1914 3.06177L13.0488 3.10669C13.0466 3.10741 13.0442 3.10793 13.042 3.10864C12.9692 2.98657 12.8804 2.84412 12.7744 2.69653L12.6357 2.51196C12.44 2.26398 12.2067 2.01901 11.9463 1.83423C11.8485 1.76485 11.7483 1.70932 11.6494 1.66235L11.6514 1.63013ZM10.3613 1.57153C10.1558 1.61499 9.98387 1.68881 9.82031 1.7981C9.52925 1.99258 9.26508 2.30108 8.93262 2.76001L8.80469 2.70044C9.0904 2.31743 9.33697 2.04397 9.61426 1.85864C9.83602 1.71047 10.0769 1.61953 10.3613 1.57153Z"
        fill="#667085"
        fill-opacity="0.9"
        stroke="#667085"
      />
      <path
        d="M10.9697 12.0286C10.9697 11.6826 10.9697 11.3561 10.9697 11.0286"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9697 12.0286C12.9697 11.6971 12.9697 11.3608 12.9697 11.0286"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.8965 19.6155C17.2984 20.0576 19.0492 20.9863 20.1123 22.1213L20.0518 22.1584C19.014 21.0084 17.2869 20.0708 14.9043 19.6233C14.9016 19.6208 14.8993 19.6179 14.8965 19.6155ZM13.7051 20.4436L13.7676 20.4524C13.7371 20.5158 13.7083 20.5815 13.6748 20.6458C13.4363 21.1031 13.0904 21.605 12.4717 21.7688L12.4727 21.7532C12.6416 21.6988 12.7976 21.6136 12.9395 21.4963C13.1935 21.2863 13.384 20.9952 13.5459 20.6848C13.615 20.5523 13.6748 20.4188 13.7324 20.2942L13.7051 20.4436ZM9.83887 20.2014C9.91924 20.3503 10.0161 20.5131 10.1318 20.676C10.4541 21.1294 10.8983 21.5582 11.4727 21.7356L11.4717 21.7502C10.8021 21.5686 10.3225 21.0859 10.002 20.635C9.93467 20.5404 9.87437 20.4453 9.81934 20.3538L9.77051 20.2463C9.79799 20.2334 9.8204 20.2177 9.83887 20.2014ZM8.44531 19.8704C8.26969 19.9276 8.07837 19.9894 7.87695 20.0569L6.88672 20.3977C6.20037 20.6402 5.48666 20.9072 4.88867 21.1643C4.57508 21.2991 4.30927 21.4246 4.09863 21.5364C4.05561 21.5592 4.01464 21.5845 3.97363 21.6077L3.94824 21.5852C4.18591 21.456 4.47709 21.3182 4.79883 21.1799C5.4023 20.9206 6.12031 20.6507 6.80859 20.4075C7.40719 20.1959 7.98442 20.0045 8.44531 19.8547V19.8704ZM9.73926 20.0071C9.74002 20.0087 9.74045 20.0104 9.74121 20.012L9.66406 20.0071H9.73926Z"
        fill="#667085"
        fill-opacity="0.9"
        stroke="#667085"
      />
    </svg>
  );
};

export const AccountSettingSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke="#667085"
      />
      <path
        d="M13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74457 2.35523 9.35522 2.74458 9.15223 3.23463C9.05957 3.45834 9.0233 3.7185 9.00911 4.09799C8.98826 4.65568 8.70226 5.17189 8.21894 5.45093C7.73564 5.72996 7.14559 5.71954 6.65219 5.45876C6.31645 5.2813 6.07301 5.18262 5.83294 5.15102C5.30704 5.08178 4.77518 5.22429 4.35436 5.5472C4.03874 5.78938 3.80577 6.1929 3.33983 6.99993C2.87389 7.80697 2.64092 8.21048 2.58899 8.60491C2.51976 9.1308 2.66227 9.66266 2.98518 10.0835C3.13256 10.2756 3.3397 10.437 3.66119 10.639C4.1338 10.936 4.43789 11.4419 4.43786 12C4.43783 12.5581 4.13375 13.0639 3.66118 13.3608C3.33965 13.5629 3.13248 13.7244 2.98508 13.9165C2.66217 14.3373 2.51966 14.8691 2.5889 15.395C2.64082 15.7894 2.87379 16.193 3.33973 17C3.80568 17.807 4.03865 18.2106 4.35426 18.4527C4.77508 18.7756 5.30694 18.9181 5.83284 18.8489C6.07289 18.8173 6.31632 18.7186 6.65204 18.5412C7.14547 18.2804 7.73556 18.27 8.2189 18.549C8.70224 18.8281 8.98826 19.3443 9.00911 19.9021C9.02331 20.2815 9.05957 20.5417 9.15223 20.7654C9.35522 21.2554 9.74457 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8477 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.902C15.0117 19.3443 15.2977 18.8281 15.781 18.549C16.2643 18.2699 16.8544 18.2804 17.3479 18.5412C17.6836 18.7186 17.927 18.8172 18.167 18.8488C18.6929 18.9181 19.2248 18.7756 19.6456 18.4527C19.9612 18.2105 20.1942 17.807 20.6601 16.9999C21.1261 16.1929 21.3591 15.7894 21.411 15.395C21.4802 14.8691 21.3377 14.3372 21.0148 13.9164C20.8674 13.7243 20.6602 13.5628 20.3387 13.3608C19.8662 13.0639 19.5621 12.558 19.5621 11.9999C19.5621 11.4418 19.8662 10.9361 20.3387 10.6392C20.6603 10.4371 20.8675 10.2757 21.0149 10.0835C21.3378 9.66273 21.4803 9.13087 21.4111 8.60497C21.3592 8.21055 21.1262 7.80703 20.6602 7C20.1943 6.19297 19.9613 5.78945 19.6457 5.54727C19.2249 5.22436 18.693 5.08185 18.1671 5.15109C17.9271 5.18269 17.6837 5.28136 17.3479 5.4588C16.8545 5.71959 16.2644 5.73002 15.7811 5.45096C15.2977 5.17191 15.0117 4.65566 14.9909 4.09794C14.9767 3.71848 14.9404 3.45833 14.8477 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224Z"
        stroke="#667085"
      />
    </svg>
  );
};

export const PostsSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.03198 20.0157C2.21832 21.1414 3.19641 22 4.375 22H18.625C19.9367 22 21 20.9367 21 19.625V15.1007M2.03198 20.0157C2.01095 19.8886 2 19.7581 2 19.625V5.375C2 4.06332 3.06332 3 4.375 3H18.625C19.9367 3 21 4.06332 21 5.375V15.1007M2.03198 20.0157L6.56905 15.4786C7.37658 14.772 8.5576 14.6947 9.45038 15.2899L10.0551 15.6929C10.9155 16.2666 12.0485 16.2175 12.8561 15.5715L16.0007 13.0556C16.8023 12.4144 17.9188 12.3642 18.7708 12.9137C18.8652 12.9746 18.9493 13.0501 19.0288 13.1296L21 15.1007M10.3125 8.9375C10.3125 10.2492 9.24921 11.3125 7.9375 11.3125C6.62582 11.3125 5.5625 10.2492 5.5625 8.9375C5.5625 7.62582 6.62582 6.5625 7.9375 6.5625C9.24921 6.5625 10.3125 7.62582 10.3125 8.9375Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const StyleSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_500_5600)">
        <path
          d="M9.57938 3H4.125C3.50368 3 3 3.50368 3 4.125V10.8491C3 11.4705 3.50368 11.9741 4.125 11.9741H9.57938C10.2007 11.9741 10.7044 11.4705 10.7044 10.8491V4.125C10.7044 3.50368 10.2007 3 9.57938 3Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8528 3H14.3984C13.7771 3 13.2734 3.50368 13.2734 4.125V5.727C13.2734 6.34834 13.7771 6.852 14.3984 6.852H19.8528C20.4741 6.852 20.9778 6.34834 20.9778 5.727V4.125C20.9778 3.50368 20.4741 3 19.8528 3Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8528 9.41992H14.3984C13.7771 9.41992 13.2734 9.92358 13.2734 10.5449V19.852C13.2734 20.4734 13.7771 20.977 14.3984 20.977H19.8528C20.4741 20.977 20.9778 20.4734 20.9778 19.852V10.5449C20.9778 9.92358 20.4741 9.41992 19.8528 9.41992Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.57938 14.5566H4.125C3.50368 14.5566 3 15.0603 3 15.6816V19.852C3 20.4733 3.50368 20.977 4.125 20.977H9.57938C10.2007 20.977 10.7044 20.4733 10.7044 19.852V15.6816C10.7044 15.0603 10.2007 14.5566 9.57938 14.5566Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const NetworkSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ContactSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.98794 5.55568C5.99484 4.49682 6.35069 4.19984 6.77976 4.06163C7.07671 3.98395 7.38812 3.97964 7.68712 4.04906C8.08072 4.16329 8.18484 4.2501 9.47547 5.53398C10.6094 6.66138 10.7227 6.7836 10.8314 7.00405C11.0393 7.39102 11.0717 7.84816 10.9206 8.26052C10.8062 8.57464 10.6437 8.78253 9.95604 9.4713L9.50751 9.92026C9.38977 10.0397 9.36208 10.2211 9.43886 10.3703C10.4355 12.0674 11.8492 13.4828 13.5465 14.4824C13.742 14.5868 13.9826 14.5531 14.1415 14.399L14.5729 13.9752C14.8395 13.7023 15.1219 13.4453 15.4185 13.2054C15.8844 12.9198 16.4648 12.8943 16.954 13.138C17.1931 13.2522 17.2721 13.323 18.4415 14.4881C19.6474 15.6886 19.6818 15.7263 19.8145 16.0016C20.0643 16.4572 20.0616 17.0091 19.8076 17.4625C19.6783 17.7184 19.5994 17.8109 18.9209 18.5031C18.5112 18.9211 18.1257 19.3027 18.0639 19.3586C17.5041 19.8212 16.786 20.0482 16.0615 19.9914C14.7361 19.8708 13.4531 19.4618 12.3028 18.7932C9.75489 17.4455 7.58574 15.482 5.99369 13.082C5.64693 12.5796 5.33865 12.0519 5.07147 11.5034C4.35471 10.277 3.98459 8.87955 4.00049 7.4598C4.05521 6.71707 4.412 6.02905 4.98794 5.55568Z"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PrivacySVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.38 21.8424 13.0193 22 12 22C10.9807 22 10.62 21.8424 9.89856 21.5273C7.23896 20.3655 3 17.6294 3 11.9914C3 11.4234 3 10.8996 3 10.4167Z"
        stroke="#667085"
      />
      <path
        d="M12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
        stroke="#667085"
      />
      <path
        d="M16 15C16 16.1046 16 17 12 17C8 17 8 16.1046 8 15C8 13.8954 9.79086 13 12 13C14.2091 13 16 13.8954 16 15Z"
        stroke="#667085"
      />
    </svg>
  );
};

export const TermsAndConditionsSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.18 8.03933L18.6435 7.57589C19.4113 6.80804 20.6563 6.80804 21.4241 7.57589C22.192 8.34374 22.192 9.58868 21.4241 10.3565L20.9607 10.82M18.18 8.03933C18.18 8.03933 18.238 9.02414 19.1069 9.89309C19.9759 10.762 20.9607 10.82 20.9607 10.82M18.18 8.03933L13.9194 12.2999C13.6308 12.5885 13.4865 12.7328 13.3624 12.8919C13.2161 13.0796 13.0906 13.2827 12.9882 13.4975C12.9014 13.6797 12.8368 13.8732 12.7078 14.2604L12.2946 15.5L12.1609 15.901M20.9607 10.82L16.7001 15.0806C16.4115 15.3692 16.2672 15.5135 16.1081 15.6376C15.9204 15.7839 15.7173 15.9094 15.5025 16.0118C15.3203 16.0986 15.1268 16.1632 14.7396 16.2922L13.5 16.7054L13.099 16.8391M12.1609 15.901L12.0272 16.3021C11.9637 16.4926 12.0133 16.7027 12.1553 16.8447C12.2973 16.9867 12.5074 17.0363 12.6979 16.9728L13.099 16.8391M12.1609 15.901L13.099 16.8391"
        stroke="#667085"
      />
      <path d="M8 13H10.5" stroke="#667085" stroke-linecap="round" />
      <path d="M8 9H14.5" stroke="#667085" stroke-linecap="round" />
      <path d="M8 17H9.5" stroke="#667085" stroke-linecap="round" />
      <path
        d="M3 10C3 6.22876 3 4.34315 4.17157 3.17157C5.34315 2 7.22876 2 11 2H13C16.7712 2 18.6569 2 19.8284 3.17157C21 4.34315 21 6.22876 21 10V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V10Z"
        stroke="#667085"
      />
    </svg>
  );
};

export const InviteFriendsSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10Z"
        stroke="#667085"
        stroke-width="1"
      />
      <path
        d="M21 10H19M19 10H17M19 10V8M19 10V12"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
      />
      <path
        d="M17.9975 18C18 17.8358 18 17.669 18 17.5C18 15.0147 14.4183 13 10 13C5.58172 13 2 15.0147 2 17.5C2 19.9853 2 22 10 22C12.231 22 13.8398 21.8433 15 21.5634"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const SignOutSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.43253 9.36709C5.73562 9.05546 5.73684 8.54893 5.43525 8.23572C5.13367 7.92253 4.64348 7.92127 4.34038 8.23291L5.43253 9.36709ZM1.22812 11.4329C0.925027 11.7445 0.923809 12.2511 1.22539 12.5643C1.52698 12.8774 2.01717 12.8787 2.32027 12.5672L1.22812 11.4329ZM2.32027 11.4329C2.01717 11.1213 1.52698 11.1226 1.22539 11.4357C0.923809 11.7489 0.925027 12.2555 1.22812 12.5672L2.32027 11.4329ZM4.34038 15.7672C4.64348 16.0787 5.13367 16.0775 5.43525 15.7643C5.73684 15.4511 5.73562 14.9445 5.43253 14.6329L4.34038 15.7672ZM1.77419 11.2C1.34662 11.2 1 11.5582 1 12C1 12.4418 1.34662 12.8 1.77419 12.8V11.2ZM16.2258 12.8C16.6534 12.8 17 12.4418 17 12C17 11.5582 16.6534 11.2 16.2258 11.2V12.8ZM4.34038 8.23291L1.22812 11.4329L2.32027 12.5672L5.43253 9.36709L4.34038 8.23291ZM1.22812 12.5672L4.34038 15.7672L5.43253 14.6329L2.32027 11.4329L1.22812 12.5672ZM1.77419 12.8H16.2258V11.2H1.77419V12.8Z"
        fill="#667085"
      />
      <path
        d="M8 15.7143C8 18.0812 9.7909 20 12 20H16C18.2091 20 20 18.0812 20 15.7143V9.28571C20 6.91878 18.2091 5 16 5H12C9.7909 5 8 6.91878 8 9.28571"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShoppingListSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.501 6.66557V20.055C19.501 21.764 18.2752 22.483 16.7783 21.6579L12.1463 19.0767C11.6513 18.8056 10.8498 18.8056 10.3547 19.0767L5.72267 21.6579C4.22579 22.483 3 21.764 3 20.055V6.66557C3 4.65009 4.65009 3 6.66557 3H15.8354C17.8509 3 19.501 4.65009 19.501 6.66557Z"
        stroke="#676A79"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FavoritesSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2563 3.41842C10.4919 2.8949 10.6098 2.63313 10.7739 2.55253C10.9163 2.48249 11.0837 2.48249 11.2262 2.55253C11.3902 2.63313 11.5081 2.8949 11.7437 3.41842L13.6206 7.58836C13.6903 7.74312 13.7251 7.8205 13.779 7.87976C13.8267 7.9322 13.885 7.97414 13.95 8.00284C14.0236 8.0353 14.1087 8.04419 14.2789 8.06197L18.8634 8.54118C19.4389 8.60133 19.7267 8.63141 19.8548 8.76103C19.966 8.87361 20.0178 9.03126 19.9945 9.18713C19.9679 9.36655 19.7529 9.55837 19.323 9.9421L15.8984 12.9985C15.7714 13.1119 15.7078 13.1686 15.6676 13.2377C15.6319 13.2989 15.6096 13.3667 15.6022 13.4369C15.5938 13.5162 15.6115 13.599 15.647 13.7649L16.6035 18.2309C16.7236 18.7916 16.7837 19.072 16.6988 19.2326C16.625 19.3723 16.4896 19.4697 16.3328 19.496C16.1522 19.5263 15.9016 19.3831 15.4002 19.0968L11.4068 16.8157C11.2586 16.731 11.1845 16.6888 11.1058 16.6722C11.036 16.6576 10.964 16.6576 10.8943 16.6722C10.8155 16.6888 10.7414 16.731 10.5932 16.8157L6.59986 19.0968C6.09851 19.3831 5.84783 19.5263 5.66726 19.496C5.51041 19.4697 5.375 19.3723 5.30127 19.2326C5.2164 19.072 5.27644 18.7916 5.39653 18.2309L6.35302 13.7649C6.38852 13.599 6.40627 13.5162 6.39784 13.4369C6.39038 13.3667 6.36812 13.2989 6.3325 13.2377C6.29225 13.1686 6.2287 13.1119 6.1016 12.9985L2.67708 9.9421C2.24715 9.55837 2.03218 9.36655 2.00545 9.18713C1.98224 9.03126 2.03396 8.87361 2.14524 8.76103C2.27337 8.63141 2.56115 8.60133 3.13672 8.54118L7.7212 8.06197C7.89136 8.04419 7.97643 8.0353 8.05 8.00284C8.11508 7.97414 8.17336 7.9322 8.22106 7.87976C8.27495 7.8205 8.30978 7.74312 8.37945 7.58836L10.2563 3.41842Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
